/** Gizlilik perdesi tanısı: `?tani=1` ile açılır (`lib/perdeTanisi.ts`). */

import { useState } from "react";
import { M } from "../../dil";
import { taniAcik, taniOku, taniSil } from "../../lib/perdeTanisi";
import { Button } from "../../ui/primitives";

const iki = (n: number, u = 2) => String(n).padStart(u, "0");
const saat = (t: number): string => {
  const d = new Date(t);
  return `${iki(d.getHours())}:${iki(d.getMinutes())}:${iki(d.getSeconds())}.${iki(d.getMilliseconds(), 3)}`;
};

export function PerdeTanisi() {
  const [kayitlar, setKayitlar] = useState(taniOku);
  if (!taniAcik()) return null;
  return (
    <div className="space-y-1 border-t border-line pt-3" aria-label={M.kilit.tani.baslik} role="group">
      <p className="text-[12px] font-semibold text-ink">{M.kilit.tani.baslik}</p>
      <p className="text-[12px] text-muted">{M.kilit.tani.aciklama}</p>
      {kayitlar.length === 0 ? (
        <p className="text-[12px] text-muted">{M.kilit.tani.bos}</p>
      ) : (
        <ol className="pf-num text-[11px] text-muted">
          {kayitlar.map((k, i) => (
            <li key={i}>
              {saat(k.t)} · {k.o} · {k.g === "hidden" ? M.kilit.tani.gizli : M.kilit.tani.gorunur} ·{" "}
              {k.f ? M.kilit.tani.odakVar : M.kilit.tani.odakYok}
            </li>
          ))}
        </ol>
      )}
      <div className="flex gap-2">
        <Button onClick={() => setKayitlar(taniOku())}>{M.kilit.tani.yenile}</Button>
        <Button
          onClick={() => {
            taniSil();
            setKayitlar([]);
          }}
        >
          {M.kilit.tani.temizle}
        </Button>
      </div>
    </div>
  );
}
